export function load(url)
{
  import(/* @vite-ignore */url)
}
export function initialize($ref, configuration) {
  const setAttribute = (selector, map) => {
    const el = $ref.value.querySelector(selector)
    Object.keys(map).forEach((prop) => (el[prop] = map[prop]))
  }
  setAttribute('online-procurement-modules-bar',configuration)
}
